import { TFTSCommonState } from './types';

export function getCustomsProcedures(state: TFTSCommonState) {
  return state.customsProcedures;
}

export function getProductsGroups(state: TFTSCommonState) {
  return state.productsGroups;
}

export function getProductsTwoSigns(state: TFTSCommonState) {
  return state.productsTwoSigns;
}

export function getProductsFourSigns(state: TFTSCommonState) {
  return state.productsFourSigns;
}

export function getProductsSixSigns(state: TFTSCommonState) {
  return state.productsSixSigns;
}

export function getProductsEightSigns(state: TFTSCommonState) {
  return state.productsEightSigns;
}

export function getProductsNineSigns(state: TFTSCommonState) {
  return state.productsNineSigns;
}

export function getProductsTenSigns(state: TFTSCommonState) {
  return state.productsTenSigns;
}

export function getOkatoTree(state: TFTSCommonState) {
  return state.okatoTree;
}

export function getCountriesTree(state: TFTSCommonState) {
  return state.countriesTree;
}
